import createFocusDecorator from 'final-form-focus';

export const focusOnErrorDecorator: any = createFocusDecorator();
